import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { GymUtils } from 'src/app/util/gym-util';
import { NetworkChangeDialogData } from './network-change-dialog-data';

@Component({
  selector: 'gymfinder-network-change-confirm-dialog',
  templateUrl: './network-change-confirm-dialog.component.html',
  styleUrls: ['./network-change-confirm-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
  ],
})
export class NetworkChangeConfirmDialogComponent {
  readonly previousTypeLabels: string[];
  readonly newTypeLabels: string[];

  private readonly translateGymType = GymUtils.getOptionsTranslation('gymTypes');

  constructor(
    private readonly dialogRef: MatDialogRef<NetworkChangeConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: NetworkChangeDialogData
  ) {
    this.previousTypeLabels = data.previousGymTypes.map(type =>
      this.translateGymType(type)
    );
    this.newTypeLabels = data.newGymTypes.map(type =>
      this.translateGymType(type)
    );
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
